import { connect } from 'react-redux';
import * as actionsAlerts from '../../actions/AlertsActions';
import { copyComment, editComment, getAddressByLatLong } from '../../actions/GlobalsActions';
import { DRAW_TYPES } from '../../constants/Misc';

import { getPcaForAlert } from "../../actions/actions";
import { setMapDrawMode } from "../../actions/setters";
import DetailsTab from '../../components/AlertsTabs/DetailsTab/DetailsTab';
import { buildDashboardEnumOptions } from '../../utils/dashboardEnums';

const diff = require('deep-diff').diff;
const _ = require('lodash');

const mapStateToProps = (state, ownProps) => {
  var workAreaOptions = state.leaksList.optionList.options.WorkAreas || [];
  var serviceProviderOptions = state.leaksList.optionList.options.ContractorID || [];
  var repairOptions = state.leaksList.optionList.options.PCARepairCodesEnum || [];
  const { selectedProject, user } = state.leaksList;
  const distributionListsCustomers = process.env.REACT_APP_DISTRIBUTION_LISTS_CUSTOMERS === 'true';
  const distributionLists = distributionListsCustomers ? state.distributionLists.lists : state.distributionLists.projectsDLists || [];
  const distributionListsOptions = distributionLists.map((listItem) => ({
    label: distributionListsCustomers ? listItem.Name : listItem.name,
    value: distributionListsCustomers ? listItem.ID : listItem.id,
  }));

  // Get event state options from server
  const eventStateOptions = state.leaksList.optionList.options.dashboard_enum_opr_state?.length > 0
    ? buildDashboardEnumOptions(state.leaksList.optionList.options.dashboard_enum_opr_state, ['is_opr_alerts', 'is_opr'])
    : [];

  // Get event priority options from server
  const eventPriorityOptions = state.leaksList.optionList.options.dashboard_enum_priority?.length > 0
    ? buildDashboardEnumOptions(state.leaksList.optionList.options.dashboard_enum_priority)
    : [];


  if (selectedProject) {
    const leaks = state.leaksList.leaksByProject[selectedProject];
    const indexMap = leaks.indexMap;
    const leaksItems = leaks.items;
    const selectedFeature = state.leaksList.leaksByProject.selectedFeature;
    const selectedLeakObj = leaksItems[indexMap[selectedFeature]];
    // const leakDetails = leaks.details[selectedFeature];
    const images = leaks.images;
    const isFixedAlert = (selectedLeakObj != null && selectedLeakObj.AlertState == 6);

    if (selectedLeakObj) {
      const initialValues = Object.assign({}, selectedLeakObj);
      const units = state.local.units;
      const distanceFactor = state.local.factor[units];
      if (initialValues.Latitude != null) {
        initialValues.Latitude = initialValues.Latitude.toFixed(6);
      }
      if (initialValues.Longitude != null) {
        initialValues.Longitude = initialValues.Longitude.toFixed(6);
      }

      return Object.assign({}, {
        distanceFactor,
        timeZone: state.local.timeZone,
        user,
        serviceProviderOptions,
        workAreaOptions,
        repairOptions,
        selectedFeature,
        selectedProject,
        initialValues,
        isFixedAlert,
        images,
        distributionListsOptions,
        eventStateOptions,
        eventPriorityOptions
      }, ownProps);
    }
  }

  return {
    timeZone: state.local.timeZone,
    workAreaOptions,
    repairOptions,
    serviceProviderOptions,
    user,
    initialValues: null,
    eventStateOptions,
    eventPriorityOptions
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: (values, dispatch, props) => {

      const differences = diff(values, props.initialValues);
      if (differences != null) {
        let res = [];
        console.log('__differences__', differences);
        
        differences.forEach((diff) => {
          const itrField = diff.path[0];
          const itrValue = itrField !== 'OverrideEndOfEvent' ? diff.lhs : (
            diff.lhs ? (new Date()).toISOString() : null
          );
          res.push({ field: itrField, value: itrValue });
        });
        if (!res.find((attr) => attr.field === 'OverrideEndOfEvent')) {
          res.push({ field: 'OverrideEndOfEvent', value: null });
        }
        dispatch(actionsAlerts.updateSingleLeak(res));
      }
    },

    openPCA: (alertId) => {
      dispatch(getPcaForAlert(alertId));
      dispatch(actionsAlerts.setOpenPCA(true, false));
    },

    openActualLeakLocation: () => {
      dispatch(actionsAlerts.openActualLeakLocation(true));
      dispatch(setMapDrawMode(true, DRAW_TYPES.POINT));
    },

    onEdit: (proxi, object, event) => {
      dispatch(editComment('details', 'Comment'));
      return true;
    },

    onCopy: (proxi, object, event) => {
      dispatch(copyComment('details', 'Comment'));
      return true;
    },

    sendNotification: (distributionListId, image) => {
      dispatch(actionsAlerts.notify(distributionListId, image, (err) => {
        if (err) {
          // console.log(err);
        } else {
          const level = 'success';
          const subject = (distributionListId == 'sms' ? 'SMS' : 'EMail');
          const message = `${subject} sent successfully`;
          ownProps.pageNotification(message, level);
        }
      }));
    },

    // notifyByEmail: (addressee, mapImageBase64) => {
    //   dispatch(actionsAlerts.notify('email', addressee, mapImageBase64, (err) => {
    //     if (err) {
    //       console.log(err);
    //     } else {
    //       const level = 'success';
    //       const message = 'Mail sent successfully'
    //       ownProps.pageNotification(message, level);
    //     }
    //   }));
    // },

    // notifyBySms: (phoneNumber) => {
    //   dispatch(actionsAlerts.notify('sms', phoneNumber, null, (err) => {
    //     if (err) {
    //       console.log(err);
    //     } else {
    //       const level = 'success';
    //       const message = 'SMS sent successfully'
    //       ownProps.pageNotification(message, level);
    //     }
    //   }));
    // },

    getAddressByLatLong: (proxi, object, event) => {
      dispatch(getAddressByLatLong('details', 'StreetAddress'));
      return true;
    },

    getMapCapture: () => ownProps.getMapCapture(),

    addToDashboard: (data) => {
      dispatch(actionsAlerts.addAlertToDashboard(data, (err) => {
        if (err) {
          const level = 'error';
          const message = 'Failed to add alert to dashboard';
          ownProps.pageNotification(message, level);
        } else {
          const level = 'success';
          const message = 'Alert successfully added to dashboard';
          ownProps.pageNotification(message, level);
        }
      }));
    }
  };
}

const CDetailsTab = connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsTab);

export default CDetailsTab;
